import { emporiModule } from '@empori/util';
import { EpcTranslations } from './primeflowTypes';

emporiModule('primeflowLoaded', {
  primeflow: {
    InitEpc(iframeEl: HTMLElement, email: string, messageOrigin: string, translations: EpcTranslations) {
      import(/* webpackChunkName: "primeflow-epc" */'./util/epc')
        .then(fn => fn.default(iframeEl, email, messageOrigin, translations));
    },
    InitPartStream() {
      import(/* webpackChunkName: "primeflow-partstream" */'./util/partstream')
        .then(fn => fn.default());
    }
  }
});